import React from 'react';
import { AffiliationDocument, LocationDocument } from '../types';
import AffiliationItem from './AffiliationItem';

const AffiliationsList = ({
	locations,
	currentLatitude,
	currentLongitude,
	onSelect = () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
	hideDistance = false,
}: {
	locations: LocationDocument[];
	currentLatitude: number;
	currentLongitude: number;
	onSelect?: (id: number) => void;
	hideDistance?: boolean;
}) => {
	const handleAffiliationItemClick = (
		e: React.MouseEvent<Element>,
		affiliation: AffiliationDocument
	) => {
		const target = e.target as HTMLElement;
		if (
			target.tagName === 'A' ||
			target.tagName === 'BUTTON' ||
			target.closest('a') ||
			target.closest('button')
		) {
			return;
		}

		const permalink = `${window.findaConnector.affiliationBaseUrl}/${affiliation.slug}`;
		window.location.href = permalink;
	};

	const rendered: number[] = [];

	return (
		<section className="fi-affiliations-list">
			{locations.map((location) => {
				if (location.affiliations?.length) {
					return location.affiliations.map((affiliation) => {
						const id = affiliation.document_location.id;

						// If the affiliation has been rendered by another location, skip it.
						if (rendered.includes(id)) {
							return null;
						}
						rendered.push(id);

						return (
							<AffiliationItem
								key={id}
								affiliation={affiliation}
								location={location}
								currentLatitude={currentLatitude}
								currentLongitude={currentLongitude}
								hideDistance={hideDistance}
								onClick={(e) => {
									handleAffiliationItemClick(e, affiliation);
								}}
							/>
						);
					});
				}

				return null;
			})}
		</section>
	);
};

export default AffiliationsList;
